import { render } from "./RomansBook.vue?vue&type=template&id=d4d0a146"
import script from "./RomansBook.vue?vue&type=script&lang=js"
export * from "./RomansBook.vue?vue&type=script&lang=js"

import "./RomansBook.vue?vue&type=style&index=0&id=d4d0a146&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__